import i18next from "i18next";

export function getAge(dateOfBirth) {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export function formatDate(date) {
  const lang = i18next.language;
  return new Date(date).toLocaleDateString(lang === "th" ? "th-TH" : "en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

export function formatMoneyNumber(number) {
  if (!number) return "0.00";
  return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getIconPath(iconName) {
  return `/assets/img/ci/icon/${iconName}.svg`;
}

export function formatThaiTime(date) {
  const lang = i18next.language;
  return new Date(date).toLocaleTimeString(lang === "th" ? "th-TH" : "en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function formatCurrency(amount) {
  const lang = i18next.language;
  return new Intl.NumberFormat(lang === "th" ? "th-TH" : "en-US", {
    style: "currency",
    currency: "THB",
  }).format(amount);
}

export function formatThaiDate(dateString, yearMode = "BC") {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const thaiMonths = [
    "ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.",
    "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."
  ];

  const engMonths = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const day = date.getDate().toString().padStart(2, "0");
  const month =
    i18next.language === "th" ? thaiMonths[date.getMonth()] : engMonths[date.getMonth()];
  const year =
    yearMode === "BC" && i18next.language === "th"
      ? (date.getFullYear() + 543).toString()
      : date.getFullYear().toString();

  return `${day} ${month} ${year}`;
}

export function containsOnlyNumber(string) {
  return /^[0-9]*$/.test(string);
}
